import axios from "axios";
import { clientVitalsAPI } from "../secrets";
import { userTypes } from "../types";

export const userById = async (userId: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/fetch/${userId}`);
  
        return result?.data
    } catch (error) {
        throw error;
    }
}

export const fetchTrustedPartners = async () => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/trusted-partners/fetch`);
        console.log({result})
        return result
    } catch (error) {
        throw error;
    }
}

export const usersByType = async (type: userTypes.AccountTypes) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/types/${type}`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const clientsByConsultants = async (consultantId: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/clients/${consultantId}`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const clientsByCompany = async (subscriberId: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/sub/clients/${subscriberId}`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const clientsByMember = async (memberId: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/clients/mem/${memberId}`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const membersByCompany = async (companyId: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/users/sub/members/${companyId}`);

        console.log({result})
        return result?.data
    } catch(error) {
        throw error;
    }
}

export const articles = async () => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/resources/articles`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const articleById = async (id: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/resources/articles/${id}`);

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const clientCreditApplications = async (email: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/dynamo/applications/client-applications`, {
            email
        });

        return result?.data;
    } catch (error) {
        throw error;
    }
}

export const creditApplicationById = async (id: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/applications/id/${id}`);

        return result?.data?.creditApp?.Items[0];
    } catch (error) {
        throw error;
    }
}

export const mapById = async (id: string) => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/dynamo/maps/id/${id}`);

        return result?.data?.map
    } catch (error) {
        throw error;
    }
}